export default {
  title: 'KeyPal 관리자',
  desc: 'KeyPal 펌웨어 업그레이드 도구',
  download: 'KeyPal Bridge 다운로드',
  onLine: '온라인 업그레이드',
  goDesktop: '컴퓨터에서 실행해 주세요',
  macTitle: 'Mac(Apple Silicon)',
  question_1: '데스크톱 앱을 통해 KeyPal을 업그레이드하는 방법은?',
  question_2: '웹을 통해 업그레이드하는 방법은?',
}
